/*
 * @Description: KOL参与图
 * @Author: yy
 * @LastEditors: yy
 * @Date: 2019-02-19 17:19:59
 * @LastEditTime: 2020-09-16 11:14:04
 */
import baseChart from './customBaseChart';



const handleData = (item, index, center) => {

  const colorList = ['#fa8b5a', '#f8aa76', '#fac19c', '#fce0cd', '#b0d9b8', '#dbeedf', '#ee9c99', '#f7d2d1', '#4fb7ed', '#99d6f5', '#caeafa']
  const startAngle = [180, 180, 180, 180, 90, 90, 0, 0, 270, 270, 270, 180, 0, 90, 270, 270,180, 0, 90, 270, 270]

  return {
    name: item.name,
    type: 'pie',
    radius: [0, item.radius],
    center: [center.x, center.y],
    roseType: 'area',
    startAngle: startAngle[index],
    zlevel: 12-index,
    label: {
      normal: {
        show: false,
      },
    },
    lableLine: {
      normal: {
        show: false
      },
    },
    itemStyle: {
      normal: {
        color: colorList[index], //'#fa8b5a',
        borderWidth: 1,
        //   borderColor:'#000'
      }
    },
    data: (function () {
      if (item.value.length > 4) {
        item.value.length = 4
      }
      return item.value
    })()
  }
}


function calculate(list) {
  let result = []
  let wb_num = list[0] + list[1] + list[2] + list[3]
  let wx_num = list[4] + list[5]
  let tt_num = list[6] + list[7]
  let zh_num = list[8] + list[9] + list[10]
  var base_num = wb_num
  if (wx_num > base_num) {
    base_num = wx_num
  }
  if (tt_num > base_num) {
    base_num = tt_num
  }
  if (zh_num > base_num) {
    base_num = zh_num
  }
  let wb_rate = Math.sqrt(wb_num / base_num)
  let wx_rate = Math.sqrt(wx_num / base_num)
  let tt_rate = Math.sqrt(tt_num / base_num)
  let zh_rate = Math.sqrt(zh_num / base_num)

  result[0] = list[0] == 0 ? 0 : Math.sqrt(list[0] / wb_num) * wb_rate * 100
  result[1] = list[1] == 0 ? 0 : Math.sqrt((list[0] + list[1]) / wb_num) * wb_rate * 100
  result[2] = list[2] == 0 ? 0 : Math.sqrt((list[0] + list[1] + list[2]) / wb_num) * wb_rate * 100
  result[3] = list[3] == 0 ? 0 : 100 * wb_rate

  result[4] = list[4] == 0 ? 0 : Math.sqrt(list[4] / wx_num) * wx_rate * 100
  result[5] = list[5] == 0 ? 0 : 100 * wx_rate

  result[6] = list[6] == 0 ? 0 : Math.sqrt(list[6] / tt_num) * tt_rate * 100
  result[7] = list[7] == 0 ? 0 : 100 * tt_rate

  result[8] = list[8] == 0 ? 0 : Math.sqrt(list[8] / zh_num) * zh_rate * 100
  result[9] = list[9] == 0 ? 0 : Math.sqrt((list[8] + list[9]) / zh_num) * zh_rate * 100
  result[10] = list[10] == 0 ? 0 : 100 * zh_rate

  // for(let i = 0, len = list.length; i < len; i++) {
  //   result[ i + 11 ] = list[i] / 
  //   result[11] = (parseFloat(list[0]) / wb_num * 100).toFixed(2)
  // }
  result[11] = (parseFloat(list[0]) / wb_num * 100).toFixed(2)
  result[12] = (parseFloat(list[1]) / wb_num * 100).toFixed(2)
  result[13] = (parseFloat(list[2]) / wb_num * 100).toFixed(2)
  result[14] = (parseFloat(list[3]) / wb_num * 100).toFixed(2)
  result[15] = (parseFloat(list[4]) / wx_num * 100).toFixed(2)
  result[16] = (parseFloat(list[5]) / wx_num * 100).toFixed(2)
  result[17] = (parseFloat(list[6]) / tt_num * 100).toFixed(2)
  result[18] = (parseFloat(list[7]) / tt_num * 100).toFixed(2)
  result[19] = (parseFloat(list[8]) / zh_num * 100).toFixed(2)
  result[20] = (parseFloat(list[9]) / zh_num * 100).toFixed(2)
  result[21] = (parseFloat(list[10]) / zh_num * 100).toFixed(2)

  return result
}

const KOL = (opt = {}) => {
  
  const list = opt.list || Array(11).fill({}).map((item, index) => ({name: index + '', value: (index + 15) * Math.random() * 10}));
  const num_array = list.map(v => parseInt(v.value));

  const result_array = calculate(num_array)

  const legend = list.map(v => v.name)

  const center = opt.center || {
    x: '50%',
    y: '60%'
  }

  const seriesList = list.map((item, index) => ({
    name: item.name,
    roam: true,
    radius: `${result_array[index]}%`,
    value: [result_array[index + 11], 0, 0, 0],
  }))

  return Object.assign(baseChart(opt), {
    tooltip: {
      trigger: 'item',
      formatter: function (params, data) {
        return params.seriesName + '<br/>' + params.data + '%';
      }
    },
    legend: {
      selectedMode: false,
      orient: 'vertical',
      right: 10,
      bottom: 10,
      data: legend,
    },
    grid: {
      top: 80,
      bottom: 30
    },
    series: seriesList.map((item , index) => handleData(item, index, center))
  })
};

export default KOL;


// WEBPACK FOOTER //
// src/chart/_KOL.js